import CheckPage from "../containers/Check/CheckPage"
import CheckInitializePage from "../containers/CheckInitialize/CheckInitializePage"

let CheckSubRoutes = [
    {
        path: '/checks-initialize/*',
        container: CheckInitializePage,
        exact: true,
    },
    {
        path: '/checks/*',
        container: CheckPage,
        exact: true,
    },
]
export default CheckSubRoutes